import { LegalPage } from "../components/LegalPage";

export default function Terms() {
  return <LegalPage i18nKey="terms" />;
}
